import { render, staticRenderFns } from "./Referencia.vue?vue&type=template&id=5ae05446&"
import script from "./Referencia.vue?vue&type=script&lang=js&"
export * from "./Referencia.vue?vue&type=script&lang=js&"
import style0 from "./Referencia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports